import HttpService from './baseHttp'

// 库存异动单查询
export const HttpGetWarehouseMoveList = (data = {}) => HttpService.post("/api/v2/warehouse/move/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 库存异动单重新审核
export const HttpConfirmWarehouseMove = (data = {}) => HttpService.post("/api/v2/warehouse/move/confirm", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 库存异动单添加备注
export const HttpAddRemark = (data = {}) => HttpService.post("/api/v2/warehouse/move/addRemark", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 库存异动单忽略差异
export const HttpIgnoreComplete = (data = {}) => HttpService.post("/api/v2/warehouse/move/ignoreComplete", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 查询明细
export const HttpWarehouseMoveDetail = (data = {}) => HttpService.post("/api/v2/warehouse/move/detail", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 查询调整明细
export const HttpMoveItemDetail = (data = {}) => HttpService.post("/api/v2/warehouse/move/itemDetail", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 查看操作历史
export const HttpGetMoveLog = (data = {}, config) => HttpService.get('/api/v2/OrderLog/query', { params: data });